var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"inner"},[_c('svg-icon',{staticStyle:{"height":"55px","width":"300px","margin-bottom":"3rem"},attrs:{"icon":`ng-logo-nabogo`}}),_vm._t("default"),_c('div',{staticClass:"store-links"},[_c('store-link',{attrs:{"store":"google"}}),_c('store-link',{attrs:{"store":"apple"}})],1)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }